export enum Gender {
  Undefined = 0,
  Male = 1,
  FeMale = 2
}

export enum EventPriceForm {
  NET = "net",
  GROSS = "gross"
}

export enum EventTimeframe {
  ALL = "all",
  CURRENT = "current",
  UPCOMING = "upcoming",
  PAST = "past",
  CANCELLED = "cancelled",
  INACTIVE = "inactive"
}

export enum EventType {
  COURSE = "course",
  EVENT = "event",
  CONFERENCE = "conference"
}

export enum BookingStatus {
  STARTED = "started",
  PENDING_ONLINE_PAYMENT_CONFIRMATION = "pending_online_payment_confirmation",
  PENDIN_CONFIRMATION = "pending_confirmation",
  CONFIRMED = "confirmed",
  CANCELLED = "cancelled",
  ABORTED = "aborted",
  ERRORED = "errored"
}

export enum BillingType {
  FIXED = "fixed",
  HOURLY = "hourly"
}

export interface IFaxNumber {
  id?: string | null;
  prefix?: string | null;
  number?: number | null;
}

export interface IPhoneNumber {
  id?: string | null;
  prefix?: string | null;
  number?: number | null;
}

export interface ITableParams {
  current_page?: number | null;
  from?: number | null;
  last_page?: number | null;
  per_page?: number | null;
  to?: number | null;
  total?: number | null;
}

export interface IPagination {
  page?: number;
  per_page?: number | null;
  search?: string;
  to?: number | null;
}

export interface IRoute {
  path?: string;
  name?: string;
}

export interface IContactPerson {
  id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  department?: string;
  gender?: Gender;
}

export interface ICountryState {
  id?: number;
  slug?: string;
  name?: string;
}

export interface ICountry {
  id?: number;
  slug?: string;
  code?: string;
  states?: Array<ICountryState> | null;
}

export interface ICustomer {
  id?: number | null;
  first_name?: string | null;
  last_name?: string | null;
  gender?: Gender | null;
  title?: string | null;
  email: string | null;
  birthdate?: Date | null;
  color_code?: string | null;
  note?: string | null;
  position?: string | null;
  number?: number | null;
  department?: string | null;
  phone_number?: IPhoneNumber;
  address?: IAddress;
}

export interface ICustomerType {
  id: number;
  name: string;
}

export interface ICustomerGroup {
  id?: number;
  name?: string | null;
  description?: string | null;
  locked?: boolean | null;
  customers_count?: number;
  created_at?: Date;
  updated_at?: Date;
}

export interface IOperator {
  id?: number | null;
  name?: string | null;
  email?: string | null;
  website?: string | null;
  fiscal_details?: IFiscalDetails;
  contact_person?: IContactPerson;
  address?: IAddress;
}

export interface IFiscalDetails {
  uid?: string;
  zvr?: string;
  dvr?: string;
  fn?: string;
}

export interface IPartner {
  id?: number;
  name?: string;
  code?: string | number;
  disabled?: boolean;
}

export interface IVenue {
  id?: number;
  name?: string | null;
  short_name?: string;
  description?: string | null;
  address?: IAddress;
  opening_times?: Array<IOpeningTime>;
  use_facility_opening_times?: boolean;
  use_facility_address?: boolean;
  child_venues?: Array<IVenue>;
}

export interface IBooking {
  id?: number;
  status?: BookingStatus;
  customer?: ICustomer;
  payment_type?: IPaymentType;
  internal_note?: string;
  total_price?: IEventPrice;
  venue_bookings?: Array<IVenueBooking>;
  event_bookings?: Array<IEventBooking>;
}

export interface IVenueBooking {
  id?: number;
  venue?: IVenue;
  automatic_price?: boolean;
  venue_price?: IEventPrice;
  starts_at?: Date;
  ends_at?: Date;
  discount?: IDiscount;
}

export interface IVenuePrice {
  id?: number;
  type?: string;
  name?: string | null;
  description?: string | null;
  form?: EventPriceForm;
  amount?: number;
  vat_id?: number;
  usable_online?: boolean;
  venue_ids_to_attach?: Array<number>;
  public_holiday?: boolean;
}

export interface IAddress {
  country_id?: number | null;
  state_id?: number | null;
  city?: string | null;
  post_code?: number | null;
  street_name?: string | null;
  street_number?: string | null;
  additional_information?: string | null;

  [key: string]: any;
}

export interface IOpeningTime {
  id?: number;
  day?: number | string;
  open_time?: Date;
  close_time?: Date;
}

export interface IFacility {
  id?: number;
  name?: string;
  short_name?: string;
  address?: IAddress;
  contact_person?: ICustomer;
  service_ids?: Array<number>;
  services?: Array<IService>;
  venues?: Array<IVenue>;
  opening_times?: Array<IOpeningTime>;
}

export interface IService {
  id?: number;
  name?: string;
}

export interface IPaymentType {
  id?: number;
  slug?: string;
}

export interface IDiscount {
  id?: number;
  value?: number;
}

export interface IEvent {
  id?: number;
  name?: string | null;
  short_name?: string | null;
  type?: string | null;
  bookability?: boolean;
  bookable_individual_appointments?: boolean;
  bookable_online?: boolean;
  bookable_from?: Date | null;
  bookable_until?: Date | null;
  start_date?: Date | null;
  end_date?: Date | null;
  freebie?: boolean;
  waitlist_enabled?: boolean;
  waitlist_max_places?: number | null;
  waitlist_autofill_free_places?: boolean;
  birthdate_mandatory?: boolean;
  cancelled?: boolean;
  max_participants?: number | null;
  online_max_participants?: number | null;
  disable_online_payment?: boolean;
  image?: File;
  brochures?: Array<File>;
  created_at?: Date;
  updated_at?: Date;
  instructor_ids?: Array<any>;
  audience_ids?: Array<any>;
}

export interface IVat {
  id?: number;
  name?: string;
  value?: number;
}

export interface IEventPrice {
  id?: number;
  type?: string;
  name?: string | null;
  description?: string | null;
  form?: EventPriceForm;
  amount?: number;
  amount_net?: number;
  amount_gross?: number;
  vat_id?: number;
  vat?: IVat;
  usable_online?: boolean;
  customerGroup?: string;
}

export interface IEventBooking {
  id?: number;
  event?: IEvent;
  event_price?: IEventPrice;
  discount?: IDiscount;
}

export interface IInventoryProductBooking {
  id?: number;
  inventory_product?: IInventoryProduct;
  inventory_product_price?: IInventoryProductPrice;
  discount?: IDiscount;
  starts_at?: Date;
  ends_at?: Date;
  units?: number;
  status?: BookingStatus;
  amount_net?: number;
  amount_gross?: number;
  amount_net_before_discount?: number;
  amount_gross_before_discount?: number;
}

export interface IInventoryProductPrice {
  id?: number;
  form?: EventPriceForm;
  billing_type?: BillingType;
  amount_net?: number;
  amount_gross?: number;
  vat?: IVat;
}

export interface IInventoryProduct {
  id?: number;
  name?: string | null;
  short_name?: string | null;
  description?: string | null;
  max_available_units?: number;
  accounting_code?: string;
  bookable_online?: boolean;
  min_booking_mins?: number;
  max_booking_mins?: number;
  lead_mins?: number;
  follow_up_mins?: number;
  price?: IEventPrice;
  facility_ids?: Array<number | undefined>;
  facilities?: IFacility;
  vat_id?: number;
  amount?: number | null;
  form?: EventPriceForm;
  billing_type?: BillingType;
}

export interface IOrganization {
  id?: number;
  name?: string | null;
  type?: string | null;
  email?: string | null;
  founding_year?: string | null;
  internal_note?: string | null;
  website?: string | null;
  customers_count?: number;
  phone_number?: IPhoneNumber;
  fax_number?: IFaxNumber;
  address?: IAddress;
  uid?: string | null;
  dvr?: string | null;
  zvr?: string | null;
  created_at?: Date;
  updated_at?: Date;
}

export interface IParticipant {
  id?: number | null;
  first_name?: string | null;
  last_name?: string | null;
  title?: string | null;
  email?: string | null;
  birthdate?: Date | null;
  gender?: Gender | null;
  customer?: ICustomer | null;
}

export interface ICategory {
  id?: number;
  name?: string | null;
  created_at?: Date;
  updated_at?: Date;
}

export interface IAppointment {
  id?: number;
  event_id?: number;
  starts_at?: Date | string | null;
  ends_at?: Date | string | null;
  venue_id?: number | null;
  venue?: IVenue;
  created_at?: Date;
  updated_at?: Date;
}

export interface IAudience {
  id?: number;
  slug?: string;
  name?: string;
  icon?: string;
  created_at?: Date;
  updated_at?: Date;
}

export interface IInstructor {
  id?: number;
  name?: string | null;
  email?: string | null;
  status?: string;
  note?: string | null;
  description?: string | null;
  display_phone_number?: boolean;
  display_email?: boolean;
  website?: string | null;
  facebook_link?: string | null;
  youtube_link?: string | null;
  twitter_link?: string | null;
  profile_image?: File;
  phone_number?: IPhoneNumber;
  category_ids?: Array<any>;
  categories?: Array<ICategory>;
  created_at?: Date;
  updated_at?: Date;
}

export interface IUser {
  id?: number;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  password?: string | null;
  new_password?: string | null;
  new_password_confirmation?: string | null;
}
